import { MenuCategory } from "./menu.model";

export interface BodyUserInformation {
  usuario: string;
}
export interface ResponseUserInformation {
  "public userInformation": PublicUserInformation;
}

export interface PublicUserInformation {
  perfil:     Profile[];
  sucursales: Branches[];
  permisos:   PermissionsMenu;
  menu:       Menu[];
}
export interface Profile {
  nombre_usuario: string;
  rol:            UserRoleEnum;
}

export enum UserRoleEnum {
  SUPERADMIN = "ROLE_SUPERADMIN",
  ADMIN = "ROLE_ADMIN",
  USER = "ROLE_USER",
  MONITOR = "ROLE_MONITOR",
}

export interface Branches {
  nombre: string;
  id:     number;
}

export interface PermissionsMenu {
  [rol: string]: string[];
  MENU_DEFECTO: string[];
}

export interface Menu {
  id:         string;
  title:      string;
  icon:       string;
  categories: MenuCategory[];
  route?:     string;
}
